import type { FrontendMessageInstanceEventWithoutRecipient } from '@post-office/shared-contracts/message-instance-event';

const DEFAULT_PATH = `/gateway/api/post-office/api/v1/message-instance-event/bulk`;
const FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const MESSAGE_EVENTS_BATCH_SIZE = 30;

if (typeof fetch === 'undefined') {
	// If fetch is not supported, load the polyfill.
	require('whatwg-fetch');
}

export class MessageInstanceEventClient {
	private readonly endpointUrl: string = DEFAULT_PATH;
	private scheduledTimeout: number | null = null;
	private batchEvents: FrontendMessageInstanceEventWithoutRecipient[] = [];

	public async sendMessageInstanceEvent(
		event: FrontendMessageInstanceEventWithoutRecipient,
	): Promise<void> {
		this.batchEvents.push(event);
		if (this.scheduledTimeout === null) {
			this.scheduledTimeout = globalThis.window.setTimeout(
				this.flushBatchEvents.bind(this),
				FLUSH_BATCH_EVENTS_TIMEOUT,
			);
		}
	}

	private async sendEventsToBackend(events: FrontendMessageInstanceEventWithoutRecipient[]) {
		const url = `${this.endpointUrl}`;
		const response = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(events),
		});
		if (!response.ok) {
			// eslint-disable-next-line no-console
			console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
		}
	}

	private async flushBatchEvents() {
		if (this.batchEvents.length === 0) {
			return;
		}

		if (this.batchEvents.length > MESSAGE_EVENTS_BATCH_SIZE) {
			const batch = this.batchEvents.slice(0, MESSAGE_EVENTS_BATCH_SIZE);
			await this.sendEventsToBackend(batch);
			if (this.scheduledTimeout !== null) {
				globalThis.window.clearTimeout(this.scheduledTimeout);
			}
			this.batchEvents = this.batchEvents.slice(MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
			this.scheduledTimeout = globalThis.window.setTimeout(
				this.flushBatchEvents.bind(this),
				FLUSH_BATCH_EVENTS_TIMEOUT,
			);
			return;
		}

		await this.sendEventsToBackend(this.batchEvents);
		this.batchEvents = [];

		if (this.scheduledTimeout !== null) {
			globalThis.window.clearTimeout(this.scheduledTimeout);
			this.scheduledTimeout = null;
		}
	}
}
